import _ from 'lodash';
import React from 'react';
import { Redirect, withRouter } from 'react-router'; // import the react-router-dom components
import { Roles } from 'constants/authRoles';
import NavigationConfig, { IPage } from '../../navigation/config';
import { SideBarConfig } from '../../navigation/config/Routes';
import { ReducerKeys } from '../../redux/config';
import { getState } from '../../redux/store';
import reactLogger from 'utils/logger';
import * as AuthSelectors from 'redux/reducers/gl_auth_reducer/selectors';
import * as ArrayUtils from 'utils/arrays';
import { getNavbarConfig } from 'navigation/config/Routes';
import { useHostDetails } from 'redux/reducers/gl_host_provider/selectors';

const MainPage = (props: any) => {
  reactLogger.log('MainPage');
  const permissions = AuthSelectors.usePermissions();
  const isLogin = AuthSelectors.useLogin();
  const hostDetails = useHostDetails();

  const navbarConfig = React.useMemo(
    () =>
      getNavbarConfig(isLogin, permissions, hostDetails.data?.settings ?? null),
    [isLogin, permissions, hostDetails]
  );

  return (
    <Redirect
      to={
        NavigationConfig.homePage().path
        // NavigationConfig.clientAccountProfilePage().path
      }
    />
  );
  // replace main page with login Page
  // if (isLogin === false) {
  //   return <Redirect to={NavigationConfig.homePage().path} />;
  // } else {
  //   return <Redirect to={NavigationConfig.homePage().path} />;
  //   // if (navbarConfig.length === 0) {
  //   //   return <div>Page not found..</div>;
  //   // } else {
  //   //   return <Redirect to={navbarConfig[0].path || ''} />;
  //   // }
  // }
};

export default withRouter(MainPage);
